///<amd-module name="typeahead/core/geolocation/logging/GeolocationMetric" />
import {IPosition, IPositionError} from "typeahead/core/geolocation/GeolocationDataProvider";
import {TypeaheadMetric} from "typeahead/core/logging/TypeaheadMetric";

export class GeolocationMetric extends TypeaheadMetric {

    public latency: number;

    constructor(lob: string, elementId: string, beginTimestamp: number, endTimestamp: number,
                public position: IPosition, public positionError: IPositionError, activeESSTests: string) {
        super(lob, elementId, "GeolocationAsSuggestion", activeESSTests);
        this.latency = endTimestamp - beginTimestamp;
    }
}
